import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../Tostador.css";
import { plotBackground } from "../../../config/colors";

export default function PerfilFrxConcentrado() {
  // Objeto inicial de la peticion
  const initialFetch = Object.assign({
    idSeccion: 4,
    secuencia: 26,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  });

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  const [asConcentrado, setAsConcentrado] = useState(defaultObject);
  const [cuConcentrado, setCuConcentrado] = useState(defaultObject);
  const [feConcentrado, setFeConcentrado] = useState(defaultObject);
  const [sConcentdado, setSConcentrado] = useState(defaultObject);
  const [siO2Concentrado, setSiO2Concentrado] = useState(defaultObject);
  const [znConcentrado, setZnConcentrado] = useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);
      //%As Concentrado por FRX

      populateAsConcentrado(data);
      populateCuConcentrado(data);
      populateFeConcentrado(data);
      populateSConcentrado(data);
      populateSiO2Concentrado(data);
      populateZnConcentrado(data);
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateAsConcentrado(data) {
    const arrValues = [];
    const arrFechas = [];

    const quemador = data.filter(
      (element) => element.Detalle === "%As Concentrado por FRX"
    );

    quemador.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setAsConcentrado({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCuConcentrado(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "%Cu Concentrado por FRX"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCuConcentrado({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateFeConcentrado(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "%Fe Concentrado por FRX"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setFeConcentrado({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateSConcentrado(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "%S Concentrado por FRX"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setSConcentrado({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateSiO2Concentrado(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "%SiO2 Concentrado por FRX"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setSiO2Concentrado({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateZnConcentrado(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "%Zn Concentrado por FRX"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setZnConcentrado({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil FRX Concentrado Alimentación"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- %As Concentrado por FRX --------------------------------------- */}
            <Chart.Line
              name="%As Concentrado por FRX"
              data={asConcentrado.value}
              yAxis={1}
            />

            {/** -------------------------------- %Cu Concentrado por FRX --------------------------------------- */}
            <Chart.Line
              name="%Cu Concentrado por FRX"
              data={cuConcentrado.value}
              yAxis={0}
            />

            {/** -------------------------------- %Fe Concentrado por FRX --------------------------------------- */}
            <Chart.Line
              name="%Fe Concentrado por FRX"
              data={feConcentrado.value}
              yAxis={0}
            />

            {/** -------------------------------- %S Concentrado por FRX --------------------------------------- */}
            <Chart.Line
              name="%S Concentrado por FRX"
              data={sConcentdado.value}
              yAxis={0}
            />

            {/** -------------------------------- %SiO2 Concentrado por FRX --------------------------------------- */}
            <Chart.Line
              name="%SiO2 Concentrado por FRX"
              data={siO2Concentrado.value}
              yAxis={1}
            />

            {/** -------------------------------- %Zn Concentrado por FRX --------------------------------------- */}
            <Chart.Line
              name="%Zn Concentrado por FRX"
              data={znConcentrado.value}
              yAxis={1}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={asConcentrado.fecha} />

            <Chart.YAxis
              labelSuffix=" %"
              title="Contenido Cu-Fe-S, %"
              lineWidth={2}
              lineColor="white"
              min={0}
              max={40}
            />

            <Chart.YAxis
              labelSuffix=" %"
              title="Contenido As-SiO2-Zn, %"
              lineWidth={2}
              lineColor="white"
              opposite={true}
              min={0}
              max={15}
            />

            <Chart.Tooltip valueSuffix=" % " />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
